var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./GsTable.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-0248aab5\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./GsTable.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/app/gsTable/GsTable.vue
// module id = 294
// module chunks = 1